import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useLocales } from '@locales';
import { useAuthContext } from '../../../context-state/AuthContext';
import { useSnackbar } from '../../../components/minimal/snackbar';
import { ROLES_LABELS, useRole } from '../../common/guards/RoleGuard.jsx';

/**
 * Feature flag (seller-level `account.hasGroupOrders`) + reader role.
 * Data loading lives in GroupOrdersContext, so this guard stays synchronous.
 */
export const GroupOrdersGuard = ({ children }) => {
    const { getPrimaryAccount } = useAuthContext();
    const { userAllowToAccess } = useRole();
    const { enqueueSnackbar } = useSnackbar();
    const { translate } = useLocales();

    const enabled = !!getPrimaryAccount()?.hasGroupOrders;
    const allowed = userAllowToAccess(ROLES_LABELS.READER);

    useEffect(() => {
        if (!enabled) enqueueSnackbar(translate('group_orders.not_enabled'), { variant: 'error' });
        else if (!allowed) enqueueSnackbar(translate('dashboard.events.unauthorized'), { variant: 'error' });
    }, [enabled, allowed]);

    if (!enabled || !allowed) return <Navigate to="/dashboard" replace />;

    return children;
};
